///<reference path='../../typings/index.d.ts' />
///<reference path='../config.ts' />

module agi.expressions.card.controller {
    import EventBus       = agi.expressions.event.EventBus;
    import Event          = agi.expressions.event.Event;

    export class PIXIInteractionController {
        protected eventBus:EventBus = EventBus.getInstance();
        protected onMoveBind:any;
        protected pixiContainer:PIXI.Container;

        constructor (){}

        public init(pixiContainer:PIXI.Container, canvas:HTMLCanvasElement){
            this.pixiContainer = pixiContainer;
            this.pixiContainer.interactive = true;

            this.pixiContainer.on("touchstart", this.onButtonDown.bind(this));
            this.pixiContainer.on("mousedown", this.onButtonDown.bind(this));
            this.pixiContainer.on("touchend", this.onButtonUp.bind(this));
            this.pixiContainer.on("mouseup", this.onButtonUp.bind(this));
            canvas.addEventListener("mouseout", this.onButtonUp.bind(this));
            canvas.addEventListener("touchcancel", this.onButtonUp.bind(this));
        }

        protected onButtonDown(ev:PIXI.interaction.InteractionEvent):void{
            var userInteractionStarted:any = new Event("userInteractionStarted", this);
            userInteractionStarted.pixi = ev;
            this.eventBus.dispatchEvent(userInteractionStarted);

            this.onMoveBind = this.onMove.bind(this);
            this.pixiContainer.on("touchmove", this.onMoveBind);
            this.pixiContainer.on("mousemove", this.onMoveBind);
        }

        protected onMove(ev:PIXI.interaction.InteractionEvent):void{
            var userMove:any = new Event("userMove", this);
            userMove.pixi = ev;
            this.eventBus.dispatchEvent(userMove);
        }

        protected onButtonUp(ev:PIXI.interaction.InteractionEvent):void{
            var userInteractionEnd:any = new Event("userInteractionEnd", this);
            userInteractionEnd.pixi = ev;
            this.eventBus.dispatchEvent(userInteractionEnd);
            this.pixiContainer.off("touchmove", this.onMoveBind);
            this.pixiContainer.off("mousemove", this.onMoveBind);
        }
    }
}
